/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { IDefinition } from '../../core/models/common/IDefinition';
import { IExample } from '../../core/models/common/IExample';
import { IVisitor } from '../../core/visitors/IVisitor';
import { IOasPropertySchema } from '../models/IOasPropertySchema';
import { OasHeader } from '../models/OasHeader';
import { OasPathItem } from '../models/OasPathItem';
import { OasPaths } from '../models/OasPaths';
import { OasResponse } from '../models/OasResponse';
import { OasResponses } from '../models/OasResponses';
import { OasSchema } from '../models/OasSchema';
import { OasXML } from '../models/OasXML';

/**
 * The common/shared OpenAPI visitor interface.  All OpenAPI visitors must implement this.
 * @author eric.wittmann@gmail.com
 * @class
 */
export interface IOasVisitor extends IVisitor {
    visitPaths(node : OasPaths);

    visitPathItem(node : OasPathItem);

    visitResponse(node : OasResponse);

    visitResponses(node : OasResponses);

    visitXML(node : OasXML);

    visitAllOfSchema(node : OasSchema);

    visitItemsSchema(node : OasSchema);

    visitAdditionalPropertiesSchema(node : OasSchema);

    visitPropertySchema(node : IOasPropertySchema);

    visitHeader(node : OasHeader);

    visitResponseDefinition(node : IDefinition);

    visitExample(node : IExample);
}


